import React from "react";
import Router from "next/router";
import { isEmpty } from "ramda";
import moment from "moment";
import removeMarkdown from "remove-markdown";
import Head from "next/head";
import { store } from "statorgfc";
import centeredPopup from "~/lib/centeredPopup";
import {
  Course__DurationString,
  DashedString__UpperCaseOnEveryWordString,
  scrollToBookmark
} from "@obby/lib";
import BaseComponent from "~/components/lib/BaseComponent";
import InPersonClassPage from "~/views/InPersonClassPage";
import HiddenClassPage from "~/views/ClassPageHidden";
import BigPopup from "~/components/BigPopup";
import ClassReviews from "~/components/ClassReviews";
import axios from "~/config/axios";
import { facebook, google } from "~/settings";
import { CheckoutRegularPopup } from "~/wrappers/CheckoutRegularPopup";
import { CheckoutGroupSchedulePopup } from "~/wrappers/CheckoutGroupSchedulePopup";
import { CheckoutAppointmentSchedulePopup } from "~/wrappers/CheckoutAppointmentSchedulePopup";
import { CheckoutBundlePopup } from "~/wrappers/CheckoutBundlePopup";
import { CheckoutTrialPopup } from "~/wrappers/CheckoutTrialPopup";
import { CheckoutDropInPopup } from "~/wrappers/CheckoutDropInPopup";
import { CheckoutTermPopup } from "~/wrappers/CheckoutTermPopup";
import { JoinWaitingListPopup } from "~/wrappers/JoinWaitingListPopup/JoinWaitingListPopup";
// States
import AuthenticationState from "~/state/AuthenticationState";
import { GoogleReCaptchaProvider } from "react-google-recaptcha-v3";
import { TicketTypeBookingTypes } from "@obby/constants";
import { login } from "~/lib/login";
import { EnquireLargeGroupPopup } from "@obby/components";
import { DisabledBookingPopup } from "@obby/components";

export async function getServerSideProps({ res, params }) {
  try {
    const [slug, earlyAccess = false] = params.classPage;
    let response = {};
    try {
      response = await axios.get("courseGetPage", {
        params: {
          slug,
          earlyAccess
        }
      });
    } catch (error) {
      if (error?.response?.status === 404) {
        // since we haven't found we will try to see if it this slug belongs to a old one a needs redirect
        const responseRedirect = await axios.get(`checkSluRedirect/${slug}`);
        let { notFound, result } = responseRedirect.data;
        if (notFound) {
          return {
            notFound: true
          };
        } else {
          return {
            redirect: {
              destination: `/classes/${params.category}/${params.subcategory}/${result.newSlug}`,
              permanent: true
            }
          };
        }
      } else {
        throw error;
      }
    }
    let {
      data,
      tutors,
      ticketTypes,
      locations,
      unavailableTimeBlocks
    } = response.data;
    if (!data || data.status === "draft") {
      return {
        notFound: true
      };
    }

    if (
      data.category !== params.category ||
      data.subcategory !== params.subcategory
    ) {
      // we need to redirect the user
      return {
        redirect: {
          destination: `/classes/${data.category}/${data.subcategory}/${slug}`,
          permanent: true
        }
      };
    }
    const searchState = {
      tagFilters: data.category,
      resultsPerPage: 24
    };
    let results = await axios.post("AlgoliaSearchResultsNew", { searchState });
    results = results.data?.hits ?? [];

    res.setHeader(
      "Cache-Control",
      "public, s-maxage=10, stale-while-revalidate=59"
    );

    return {
      props: {
        results,
        slug,
        data,
        locations,
        tutors,
        ticketTypes,
        earlyAccess,
        unavailableTimeBlocks
      }
    };
  } catch (error) {
    throw error;
  }
}

export class ClassPageWrapper extends BaseComponent {
  constructor(props) {
    super(props);
    this.state = {
      isLoaded: false,
      data: {},
      user: false,
      slug: props.slug,
      action: null,
      actionPayload: undefined,
      waitingListSession: null,
      ticketTypes: undefined
    };
    store.connectComponentState(this, ["authentication"]);
  }

  onGiftThisClass() {


    let dataTrack = {
      event: "Add To Cart",
      name: "Add To Cart",
      type: "Class",
      option: "Gift Course",
      path: window.location.pathname || "",
      referrer: document.referrer || "",
      title: document.title || "",
      url: window.location.href
    };
    if (window.dataLayer) {
      window.dataLayer.push(dataTrack);
    }

    this.setState({
      action: "showDisabledBookingPopup",
      popupData: {gift_button: 1 },
    });
    return;
    //Router.push(`https://classbento.co.uk/workshop-experience-gift-cards`);
    // routing to classbento giftcard page
    ///Router.push(`/gift/send?c=${this.props.data._id}`);
  }

  onBuyAnObbyGiftCard() {
    this.setState({
      action: "showDisabledBookingPopup",
      popupData: {gift_button: 1 },
    });
    return;
    //Router.push(`https://classbento.co.uk/workshop-experience-gift-cards`);
  }

  onCloseAction() {
    this.setState({
      action: null,
      actionPayload: undefined
    });
  }

  onOpenDatesPopup() {
    this.setState({
      action: "showDisabledBookingPopup",
      popupData: {gift_button: 0 },
    });
    return;
    let dataTrack = {
      event: "Add To Cart",
      name: "Add To Cart",
      type: "Class",
      option: "Single Session",
      path: window.location.pathname || "",
      referrer: document.referrer || "",
      title: document.title || "",
      url: window.location.href
    };
    if (window.dataLayer) {
      window.dataLayer.push(dataTrack);
    }
    this.setState({
      action: "regularDatesCheckout"
    });
  }

  onOpenDropInDatesPopup() {
    this.setState({
      action: "showDisabledBookingPopup",
      popupData: {gift_button: 0 },
    });
    return;
    let dataTrack = {
      event: "Add To Cart",
      name: "Add To Cart",
      type: "Class",
      option: "Drop-in Session",
      path: window.location.pathname || "",
      referrer: document.referrer || "",
      title: document.title || "",
      url: window.location.href
    };
    if (window.dataLayer) {
      window.dataLayer.push(dataTrack);
    }
    this.setState({
      action: "dropInDatesCheckout"
    });
  }

  onOpenTrialDatesPopup() {
    this.setState({
      action: "showDisabledBookingPopup",
      popupData: {gift_button: 0 },
    });
    return;
    let dataTrack = {
      event: "Add To Cart",
      name: "Add To Cart",
      type: "Class",
      option: "Trial Session",
      path: window.location.pathname || "",
      referrer: document.referrer || "",
      title: document.title || "",
      url: window.location.href
    };
    if (window.dataLayer) {
      window.dataLayer.push(dataTrack);
    }
    this.setState({
      action: "trialDatesCheckout"
    });
  }

  onOpenBundleDatesPopup(bundle) {
    this.setState({
      action: "showDisabledBookingPopup",
      popupData: {gift_button: 0 },
    });
    return;
    let dataTrack = {
      event: "Add To Cart",
      name: "Add To Cart",
      type: "Class",
      option: "Bundle session",
      path: window.location.pathname || "",
      referrer: document.referrer || "",
      title: document.title || "",
      url: window.location.href
    };
    if (window.dataLayer) {
      window.dataLayer.push(dataTrack);
    }
    const { ticketTypes, data } = this.props;
    const ticketType = ticketTypes.find(
      ticketType => ticketType._id === bundle.ticketTypeId
    );
    this.setState({
      action: "bundleDatesCheckout",
      actionPayload: {
        bundle,
        ticketType
      }
    });
  }

  onOpenTermDatesPopup() {
    this.setState({
      action: "showDisabledBookingPopup",
      popupData: {gift_button: 0 },
    });
    return;
    this.setState({
      action: "termDates"
    });
  }

  onOpenGroupSchedulePopup() {
    this.setState({
      action: "showDisabledBookingPopup",
      popupData: {gift_button: 0 },
    });
    return;
    let dataTrack = {
      event: "Add To Cart",
      name: "Add To Cart",
      type: "Class",
      option: "Private session",
      path: window.location.pathname || "",
      referrer: document.referrer || "",
      title: document.title || "",
      url: window.location.href
    };
    if (window.dataLayer) {
      window.dataLayer.push(dataTrack);
    }
    const { ticketTypes } = this.props;

    this.setState({
      action: "groupScheduleCheckout",
      actionPayload: {
        ticketTypes: ticketTypes.filter(
          ticketType => ticketType.bookingType === TicketTypeBookingTypes.GROUP
        )
      }
    });
  }

  onOpenAppointmentSchedulePopup() {
    this.setState({
      action: "showDisabledBookingPopup",
      popupData: {gift_button: 0 },
    });
    return;
    const { ticketTypes } = this.props;

    this.setState({
      action: "appointmentScheduleCheckout",
      actionPayload: {
        ticketTypes: ticketTypes.filter(
          ticketType =>
            ticketType.bookingType === TicketTypeBookingTypes.APPOINTMENT
        ),
        location: this.props.locations.find(
          location =>
            location._id ===
            this.props.data.appointmentScheduleBriefing.locationId
        )
      }
    });
  }

  onGroupEnquire() {
    this.setState({
      action: "showDisabledBookingPopup",
      popupData: {gift_button: 0 },
    });
    return;
    this.setState({
      action: "enquireGroup"
    });
  }

  async onSendGroupRequests(values) {
    await axios.post(`/courses/${this.props.data._id}/enquire-group`, values);
  }

  async onSaveToWishList() {
    try {
      const isAlreadySignedIn = AuthenticationState.helpers.isSignedIn();
      if (!isAlreadySignedIn) await login(false);

      const isFavourite = AuthenticationState.helpers.isFavouriteCourse(
        this.props.data._id
      );
      if (isFavourite) {
        // remove from wish list only if the user was already signed in. If the user was not signed in,
        // means the favourite icon was toggled off and the user's intention was actually to add to wish list.
        if (isAlreadySignedIn)
          AuthenticationState.events.removeClassFromWishList.next(
            this.props.data._id
          );
      } else
        AuthenticationState.events.addClassToWishList.next(this.props.data._id);
    } catch (e) {}
  }

  onViewMoreReviews() {
    this.setState({
      action: "showReviews"
    });
  }

  redirectToBreadcrumbUrl(breadcrumb) {
    if (breadcrumb.value) {
      Router.push(breadcrumb.value);
    }
  }

  shareOnFacebook() {
    this.trackCourseShared("Facebook");
    centeredPopup(
      `https://web.facebook.com/dialog/feed?app_id=${facebook.appId}&display=popup&link=https://obby.co.uk${this.props.url.asPath}`,
      "",
      "700",
      "400"
    );
  }

  shareOnFacebookMessenger() {
    this.trackCourseShared("Facebook Messenger");
    centeredPopup(
      `https://web.facebook.com/dialog/send?app_id=${facebook.appId}&link=https://obby.co.uk${this.props.url.asPath}&display=popup&redirect_uri=https://obby.co.uk/`,
      "",
      "700",
      "400"
    );
  }

  shareOnTwitter() {
    this.trackCourseShared("Twitter");
    centeredPopup(
      `https://twitter.com/intent/tweet?text=${`${this.props.data.title} — @obbyuk&url=https://obby.co.uk${this.props.url.asPath}`}`,
      "",
      "700",
      "400"
    );
  }

  shareViaEmail() {
    this.trackCourseShared("email");
    location.href = `mailto:?subject=What do you think of doing this Obby class?&body=Thoughts on doing this “${
      this.props.data.title
    }” class? Let me know what you think!${escape("\n")}https://obby.co.uk${
      this.props.url.asPath
    }`;
  }

  getUserEmail() {
    const { emails: [{ address = "" } = {}] = [] } =
      this.state.authentication.user ?? {};
    return address;
  }

  trackCourseShared(sharedVia) {
    if (window.rudderanalytics)
      window.rudderanalytics.track("Social Share", {
        share_via: sharedVia,
        url: this.props.url.asPath,
        school_id: this.props.data.schoolId,
        school_name: this.props.data.schoolName,
        course_id: this.props.data._id,
        course_title: this.props.data.title,
        type: this.props.data.type,
        price: this.props.data.price,
        category: this.props.data.category,
        rating: this.props.data.summary.rating,
        number_of_dates: this.props.data.summary.numberOfDates || 0,
        number_of_photos: this.props.data.galleryImages.length,
        source: "marketplace"
      });
  }

  trackSeeDates(eventType = "session") {
    if (window.rudderanalytics)
      window.rudderanalytics.track("See Dates", {
        course_id: this.props.data._id,
        course_title: this.props.data.title,
        price: this.props.data.price,
        category: this.props.data.category,
        rating: this.props.data.summary.rating,
        number_of_reviews: this.props.data.summary.numberOfReviews,
        type: this.props.data.type,
        duration: this.props.data.duration,
        school_name: this.props.data.schoolName,
        school_id: this.props.data.schoolId,
        number_of_dates: this.props.data.summary.numberOfDates || 0,
        userId: "",
        url: this.props.url.asPath,
        number_of_photos: this.props.data.galleryImages.length,
        photo: this.props.data.galleryImages[0].src,
        source: "marketplace",
        eventType: eventType
      });
  }

  trackReadMore() {
    if (window.rudderanalytics)
      window.rudderanalytics.track("See More", {
        course_id: this.props.data._id,
        course_title: this.props.data.title,
        price: this.props.data.price,
        category: this.props.data.category,
        rating: this.props.data.summary.rating,
        number_of_reviews: this.props.data.summary.numberOfReviews,
        type: this.props.data.type,
        duration: this.props.data.duration,
        school_name: this.props.data.schoolName,
        school_id: this.props.data.schoolId,
        number_of_dates: this.props.data.summary.numberOfDates || 0,
        userId: "",
        url: this.props.url.asPath,
        number_of_photos: this.props.data.galleryImages.length,
        photo: this.props.data.galleryImages[0].src,
        source: "marketplace"
      });
  }

  trackReadMoreAboutHost() {
    if (window.rudderanalytics)
      window.rudderanalytics.track("See More about Teacher", {
        course_id: this.props.data._id,
        course_title: this.props.data.title,
        price: this.props.data.price,
        category: this.props.data.category,
        rating: this.props.data.summary.rating,
        number_of_reviews: this.props.data.summary.numberOfReviews,
        type: this.props.data.type,
        duration: this.props.data.duration,
        school_name: this.props.data.schoolName,
        school_id: this.props.data.schoolId,
        number_of_dates: this.props.data.summary.numberOfDates || 0,
        userId: "",
        url: this.props.url.asPath,
        number_of_photos: this.props.data.galleryImages.length,
        photo: this.props.data.galleryImages[0].src,
        source: "marketplace"
      });
  }

  removeMarkdownFromText(text) {
    if (text && typeof text === "string") {
      return removeMarkdown(text.replace(/"/g, "'"));
    }
    return "";
  }

  openWaitingListPopupForSession(session) {
    this.setState({
      action: "showDisabledBookingPopup",
      popupData: {gift_button: 0 },
    });
    //alert("Disabled for now");
    return;
    this.setState({
      action: "joinWaitingList",
      actionPayload: { session }
    });
  }

  openWaitingListPopupForClass() {
    this.setState({
      action: "showDisabledBookingPopup",
      popupData: {gift_button: 0 },
    });
    return;
    this.setState({
      action: "joinWaitingList",
      actionPayload: { session: null }
    });
  }

  // Metadata
  renderMetadata(classData) {
    let name = `${classData.title} | Obby`;
    let filteredDescription = this.removeMarkdownFromText(
      classData.shortDescription
    ).substring(0, 100);
    let subjectTag = DashedString__UpperCaseOnEveryWordString(
      classData.subcategory
    );
    let lengthTag = Course__DurationString(classData, classData.type);
    const location = this.props.locations.find(
      location => location._id === classData.summary.locationId
    );
    let onlinePrefix = classData.isOnline ? "Online" : "";
    let description = `${onlinePrefix} ${lengthTag}, ${subjectTag}, - ${filteredDescription} - London`;
    let image = isEmpty(classData.galleryImagesHuge)
      ? "/static/images/genericimage.jpg"
      : classData.galleryImagesHuge[0].url;
    let path = `/classes/${classData.category}/${classData.subcategory}/${classData.slug}`;
    const meta = {
      title: name,
      desc: description,
      image: image
    };
    let classUrl = `https://obby.co.uk${path}`;
    let startDateTime = moment();
    let endDateTime = moment().add(60, "minutes");
    if (classData.summary.nextAvailableDate) {
      startDateTime = moment(classData.summary.nextAvailableDate);
      endDateTime = moment(classData.summary.nextAvailableDate).add(
        classData.summary.duration,
        "minutes"
      );
    }
    let eventAttendanceMode = "";
    if (classData.isOnline) {
      eventAttendanceMode = "https://schema.org/OnlineEventAttendanceMode";
    } else {
      eventAttendanceMode = "https://schema.org/OfflineEventAttendanceMode";
    }
    let ldData = {
      "@context": "http://schema.org/",
      "@type": "EducationEvent",
      performer: classData.schoolName,
      organizer: {
        "@type": "Thing",
        name: "Obby",
        url: "https://obby.co.uk/"
      },
      name,
      image,
      eventStatus: "https://schema.org/EventScheduled",
      eventAttendanceMode,
      location: classData.isOnline
        ? { "@type": "VirtualLocation", url: classUrl }
        : location
        ? {
            "@type": "Place",
            name: location.name,
            address: {
              "@type": "PostalAddress",
              streetAddress: location.line1,
              addressLocality: location.city,
              postalCode: location.postcode,
              addressCountry: location.country || "UK"
            }
          }
        : {},
      startDate: startDateTime
        .tz("Europe/London")
        .format("YYYY-MM-DDThh:mm:ss z"),
      remainingAttendeeCapacity: classData.summary.availability || 10,
      maximumAttendeeCapacity: classData.summary.capacity || 10,
      description,
      review: {
        "@type": "Review",
        itemReviewed: {
          "@type": "Thing",
          name,
          description,
          image
        },
        reviewBody:
          "Had a great time! Thanks Obby for helping me find this class.",
        reviewRating: {
          "@type": "Rating",
          author: {
            "@type": "Person",
            givenName: "Tom"
          },
          worstRating: "0",
          bestRating: "10",
          ratingValue: classData.summary.rating || 9
        },
        author: {
          "@type": "Person",
          givenName: "Tom"
        }
      },
      aggregateRating: {
        "@type": "AggregateRating",
        worstRating: "0",
        bestRating: "10",
        ratingValue: classData.summary.rating || 9,
        reviewCount: classData.summary.numberOfReviews || 21
      },
      offers: {
        "@type": "Offer",
        areaServed: "London",
        price: classData.summary.price / 100,
        priceCurrency: "GBP",
        priceValidUntil: moment()
          .add(30, "days")
          .format("YYYY-MM-DDThh:mm:ss"),
        availability: "http://schema.org/LimitedAvailability",
        url: classUrl,
        itemOffered: {
          "@type": "Thing",
          name,
          description,
          image
        },
        serialNumber: classData._id,
        seller: {
          "@type": "Organization",
          name: classData.schoolName
        },
        acceptedPaymentMethod: {
          "@type": "PaymentMethod",
          url: "http://purl.org/goodrelations/v1#PaymentMethodCreditCard"
        },
        validFrom: moment().format("YYYY-MM-DDThh:mm:ss")
      },
      endDate: endDateTime.tz("Europe/London").format("YYYY-MM-DDThh:mm:ss z")
    };
    if (
      classData.hidden ||
      classData.status === "hidden" ||
      !classData.schoolCA
    ) {
      return (
        <Head>
          <title>{meta.title}</title>
          <meta name="description" content={meta.desc} />
          <meta name="robots" content="noindex, follow" />
        </Head>
      );
    } else {
      return (
        <Head>
          <title>{meta.title}</title>
          <meta name="description" content={meta.desc} />
          <meta property="fb:app_id" content={facebook.appId} />
          <meta property="og:title" content={meta.title} />
          <meta property="og:description" content={meta.desc} />
          <meta property="og:url" content={classUrl} />
          <meta property="og:image" content={meta.image} />
          <meta property="og:image:width" content="1200" />
          <meta property="og:image:height" content="630" />
          <meta property="og:image:height" content="630" />
          <meta property="og:type" content="product.item" />
          <meta property="product:retailer_item_id" content="OBBY" />
          <meta
            property="product:price:amount"
            content={(classData.summary.price / 100).toString()}
          />
          <meta property="product:price:currency" content="GBP" />
          <meta property="product:availability" content="instock" />
          <meta property="product:condition" content="new" />
          <meta property="og:site_name" content="Obby" />
          <meta property="twitter:title" content={meta.title} />
          <meta property="twitter:description" content={meta.desc} />
          <meta property="twitter:card" content="summary" />
          <meta property="twitter:image" content={meta.image} />
          <meta property="twitter:image:alt" content={meta.title} />
          <link rel="canonical" href={classUrl} />
          <script
            type="application/ld+json"
            dangerouslySetInnerHTML={{ __html: `${JSON.stringify(ldData)}` }}
          />
        </Head>
      );
    }
  }

  render() {
    if (this.props.data.status === "hidden") {
      return (
        <div>
          {this.renderMetadata(this.props.data)}
          <HiddenClassPage />
        </div>
      );
    }

    return (
      <div>
        {this.renderMetadata(this.props.data)}

        <InPersonClassPage
          googleMapURL={`https://maps.googleapis.com/maps/api/js?key=${google.mapsKey}&v=3.exp&libraries=geometry,drawing,places`}
          ticketTypes={this.props.ticketTypes}
          locations={this.props.locations}
          class={this.props.data}
          results={this.props.results}
          isSavedToWishList={AuthenticationState.helpers.isFavouriteCourse(
            this.props.data._id
          )}
          userEmail={this.getUserEmail()}
          onSaveToWishlist={this.onSaveToWishList.bind(this)}
          onFacebookShare={this.shareOnFacebook.bind(this)}
          onMessengerShare={this.shareOnFacebookMessenger.bind(this)}
          onTwitterShare={this.shareOnTwitter.bind(this)}
          onEmailShare={this.shareViaEmail.bind(this)}
          onClickReadMore={this.trackReadMore.bind(this)}
          onClickReadMoreAboutHost={this.trackReadMoreAboutHost.bind(this)}
          onSeeDatesClick={this.trackSeeDates.bind(this)}
          onGroupEnquire={this.onGroupEnquire.bind(this)}
          onRegularOptionSelect={this.onOpenDatesPopup.bind(this)}
          onAppointmentScheduleOptionSelect={this.onOpenAppointmentSchedulePopup.bind(
            this
          )}
          onGroupScheduleOptionSelect={this.onOpenGroupSchedulePopup.bind(this)}
          onTermOptionSelect={this.onOpenTermDatesPopup.bind(this)}
          onBlockBookingOptionSelect={this.onOpenBundleDatesPopup.bind(this)}
          onGiftThisClass={this.onGiftThisClass.bind(this)}
          onClickBreadcrumb={this.redirectToBreadcrumbUrl.bind(this)}
          onViewMoreReviews={this.onViewMoreReviews.bind(this)}
          onBuyAnObbyGiftCard={this.onBuyAnObbyGiftCard.bind(this)}
          onJoinWaitingList={this.openWaitingListPopupForClass.bind(this)}
          onDropInOptionSelect={this.onOpenDropInDatesPopup.bind(this)}
          onTrialOptionSelect={this.onOpenTrialDatesPopup.bind(this)}
        />

        {this.state.action === "showDisabledBookingPopup" && (
          <DisabledBookingPopup onClose={this.onCloseAction.bind(this)}
                                popupData={this.state.popupData} />
        )}

        {this.state.action === "groupScheduleCheckout" && (
          <CheckoutGroupSchedulePopup
            course={this.props.data}
            ticketTypes={this.state.actionPayload.ticketTypes}
            onClose={this.onCloseAction.bind(this)}
            unavailableTimeBlocks={this.props.unavailableTimeBlocks}
          />
        )}
        {this.state.action === "appointmentScheduleCheckout" && (
          <CheckoutAppointmentSchedulePopup
            course={this.props.data}
            location={this.state.actionPayload.location}
            ticketTypes={this.state.actionPayload.ticketTypes}
            onClose={this.onCloseAction.bind(this)}
            unavailableTimeBlocks={this.props.unavailableTimeBlocks}
          />
        )}
        {this.state.action === "enquireGroup" && (
          <EnquireLargeGroupPopup
            onClose={this.onCloseAction.bind(this)}
            onSendRequest={this.onSendGroupRequests.bind(this)}
          />
        )}
        {this.state.action === "regularDatesCheckout" && (
          <CheckoutRegularPopup
            course={this.props.data}
            locations={this.props.locations}
            tutors={this.props.tutors}
            ticketTypes={this.props.ticketTypes}
            earlyAccess={this.props.earlyAccess}
            onClose={this.onCloseAction.bind(this)}
            onViewBundles={() => scrollToBookmark("booking-options")}
            onViewTrial={() => scrollToBookmark("booking-options")}
            openWaitingListPopup={this.openWaitingListPopupForSession.bind(
              this
            )}
          />
        )}
        {this.state.action === "trialDatesCheckout" && (
          // We need to add here so we can use the hook inside the application
          <GoogleReCaptchaProvider
            reCaptchaKey={process.env.NEXT_PUBLIC_RECAPTCHA_CLIENT_KEY}
          >
            <CheckoutTrialPopup
              course={this.props.data}
              locations={this.props.locations}
              tutors={this.props.tutors}
              ticketType={this.props.ticketTypes.find(
                ticketType =>
                  ticketType._id === this.props.data.trialTicketTypeId
              )}
              earlyAccess={this.props.earlyAccess}
              onBookATerm={() => scrollToBookmark("booking-options")}
              onClose={this.onCloseAction.bind(this)}
              onOpenWaitingListPopup={this.openWaitingListPopupForSession.bind(
                this
              )}
            />
          </GoogleReCaptchaProvider>
        )}
        {this.state.action === "dropInDatesCheckout" && (
          // We need to add here so we can use the hook inside the application
          <GoogleReCaptchaProvider
            reCaptchaKey={process.env.NEXT_PUBLIC_RECAPTCHA_CLIENT_KEY}
          >
            <CheckoutDropInPopup
              course={this.props.data}
              locations={this.props.locations}
              tutors={this.props.tutors}
              ticketType={this.props.ticketTypes.find(
                ticketType =>
                  ticketType._id === this.props.data.dropInTicketTypeId
              )}
              earlyAccess={this.props.earlyAccess}
              onClose={this.onCloseAction.bind(this)}
              onOpenWaitingListPopup={this.openWaitingListPopupForSession.bind(
                this
              )}
            />
          </GoogleReCaptchaProvider>
        )}
        {this.state.action === "bundleDatesCheckout" && (
          <CheckoutBundlePopup
            bundle={this.state.actionPayload.bundle}
            ticketType={this.state.actionPayload.ticketType}
            course={this.props.data}
            locations={this.props.locations}
            tutors={this.props.tutors}
            earlyAccess={this.props.earlyAccess}
            onClose={this.onCloseAction.bind(this)}
          />
        )}
        {this.state.action === "joinWaitingList" && (
          <JoinWaitingListPopup
            sessionId={this.state.actionPayload.session?._id}
            courseId={this.props.data._id}
            onClose={this.onCloseAction.bind(this)}
          />
        )}
        {this.state.action === "termDates" && (
          <GoogleReCaptchaProvider
            reCaptchaKey={process.env.NEXT_PUBLIC_RECAPTCHA_CLIENT_KEY}
          >
            <CheckoutTermPopup
              course={this.props.data}
              locations={this.props.locations}
              onClose={this.onCloseAction.bind(this)}
              onJoinWaitingList={this.openWaitingListPopupForSession.bind(this)}
              onViewTrial={() => scrollToBookmark("booking-options")}
              ticketTypes={this.props.ticketTypes.filter(
                ticketType =>
                  ticketType.bookingType === TicketTypeBookingTypes.REGULAR
              )}
              tutors={this.props.tutors}
            />
          </GoogleReCaptchaProvider>
        )}
        <BigPopup
          isOpen={this.state.action === "showReviews"}
          onClose={this.onCloseAction.bind(this)}
        >
          <ClassReviews
            reviews={this.props.data.reviews.map(review => ({
              date: review.createdAt,
              review: review.reviewTxt,
              name: review.name,
              firstName: review.firstName,
              lastName: review.lastName,
              showOnlyFirstName: review.showOnlyFirstName,
              avatarUrl: review.avatar,
              rating: review.reviewValue
            }))}
          />
        </BigPopup>
      </div>
    );
  }
}
